import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { banners } from "@/mocks/comics";

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % banners.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + banners.length) % banners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 w-full">
          <div className="max-w-lg">
            <span className="inline-block px-3 py-1 bg-primary-500/90 text-white text-xs font-medium rounded-full mb-4">
              {banner.subtitle}
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              {banner.title}
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-6 leading-relaxed">
              {banner.description}
            </p>
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate(`/article/${banner.comicId}`)}
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即阅读
              </button>
              <button className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full border border-white/30 hover:border-white/60 text-white transition-all duration-300 cursor-pointer">
                <i className="ri-heart-line text-lg md:text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white transition-all duration-300 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white transition-all duration-300 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {banners.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current ? "bg-primary-500 w-6" : "bg-white/50 hover:bg-white/80"
            }`}
            aria-label={`切换到第${idx + 1}张`}
          ></button>
        ))}
      </div>
    </section>
  );
}